import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function RequireInstructor({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { isLoggedIn, isInstructor, isLoadingCurrentUser, isError } = useCurrentUser();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
      return;
    }

    if (!isLoadingCurrentUser && (isError || !isInstructor)) {
      navigate('/home', { replace: true });
    }
  }, [isError, isInstructor, isLoadingCurrentUser, isLoggedIn, navigate]);

  if (!isLoggedIn || isLoadingCurrentUser || isError || !isInstructor) {
    return null;
  }

  return <>{children}</>;
}
